import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appDnd]'
})
export class DndDirective {
  @Output() fileDropped = new EventEmitter<any>();
  @HostBinding('class.fileover') fileOver: boolean;

  constructor() {
  }

  // Drag Over Listener
  @HostListener('dragover', ['$event']) onDragOver($event: DragEvent): void {
    console.log('Drag Over');
    $event.preventDefault();
    $event.stopPropagation();
    this.fileOver = true;
  }

  // Drag Leave Listener
  @HostListener('dragleave', ['$event']) onDragLeave($event: DragEvent): void {
    console.log('Drag Leave');
    $event.preventDefault();
    $event.stopPropagation();
    this.fileOver = false;
  }

  // Drop Listener
  @HostListener('drop', ['$event']) onDrop($event: DragEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.fileOver = false;
    const validFiles = [];
    const files = $event.dataTransfer.files;
    const items = $event.dataTransfer.items;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind === 'file') {
        const entry = item.webkitGetAsEntry();
        if (entry.isFile) {
          validFiles.push(files[i]);
        } else if (entry.isDirectory) {
          // TODO: handle when feature is enable
          console.log(entry);
        }
      }
    }
    if (validFiles.length > 0) {
      this.fileDropped.emit(validFiles);
    }
  }
}
